export default __webpack_public_path__ + "static/media/Stage_title.5224d615.png";